var map = {
	"./dps.webp": 5764,
	"./dps_b.webp": 2125,
	"./dps_g.webp": 1150,
	"./dps_r.webp": 9821,
	"./dps_y.webp": 1704,
	"./heal.webp": 3917,
	"./heal_b.webp": 4776,
	"./heal_g.webp": 8199,
	"./heal_r.webp": 7560,
	"./heal_y.webp": 7725,
	"./tank.webp": 2871,
	"./tank_b.webp": 9338,
	"./tank_g.webp": 9409,
	"./tank_r.webp": 3418,
	"./tank_y.webp": 2115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2567;